import { getWebAppBaseUrl, isNativePlatform } from '@/lib/native'

export interface AppVersionInfo {
  version: string
  buildId: string
  builtAt: string
}

export const CURRENT_BUILD_ID = import.meta.env.VITE_BUILD_ID
export const CURRENT_APP_VERSION = import.meta.env.VITE_APP_VERSION

export async function fetchLiveAppVersion(): Promise<AppVersionInfo | null> {
  try {
    const versionUrl = isNativePlatform() ? `${getWebAppBaseUrl()}/version.json?t=${Date.now()}` : `/version.json?t=${Date.now()}`
    const response = await fetch(versionUrl, { cache: 'no-store' })
    if (!response.ok) {
      return null
    }

    const data = (await response.json()) as AppVersionInfo
    return data.version ? data : null
  } catch {
    return null
  }
}
